import {injectableInstance} from '../utils/Utils'

angular.module('webtrader').factory('accountInterceptor', function ($injector) {
  return {
    request: (config) => {
      $injector.invoke((Account) => {
        if (!Account.isGuest && Account.currentLogin && Account.accounts[Account.currentLogin] && Account.accounts[Account.currentLogin].token)
          config.headers['X-Trader-Token'] = Account.accounts[Account.currentLogin].token
      })
      return config;
    },
  }
});

angular.module('webtrader').config(function ($httpProvider) {
  $httpProvider.interceptors.push('accountInterceptor')
})


@injectableInstance("webtrader", "$rootScope", "$http", "$q", "$state", "localStorageService")
export class Account {
  loadAccounts() {
    this.accounts = this.localStorageService.get('accounts') || {}
  }
  saveAccounts() {
    this.localStorageService.set('accounts', this.accounts)
  }

  setVar(name, val) {
    this.loadAccounts()
    this.accounts[this.currentLogin] = this.accounts[this.currentLogin] || {}
    this.accounts[this.currentLogin][name] = val
    this.saveAccounts()
  }
  getVar(name) {
    this.loadAccounts()
    return (this.accounts[this.currentLogin] || {})[name]
  }

  signIn(login, password, fast=false, auth_key="") {
    this.isLoading = true
    if (auth_key) {
      login = 1;
      password = 1;
    }
    return this.$http.post('/my/webtrader/api/account/signin/', {
      login: login, password: password, fast: fast, auth_key: auth_key
    }).then((res) => {
      this.loadAccounts()
      this.accounts[res.data.login] = res.data
      this.saveAccounts()
      return res
    }).catch((err) =>{
      console.log('catch signIn: ', err);
      if (err.fast) {
        window.location.href = '/my/webtrader/login/';
      } else {
        if (!err.data.detail) {
          const errMessage = err.data.login || err.data.password;
          alert(errMessage);
          throw err;
        } else {
          throw err;
        }
      }
    })
  }

  initGuest(type) {
    this.isGuest = true
    this.currentLogin = type
    this.BASE_URL = `/my/webtrader/api/account/${this.currentLogin}`
    this.summary = {}
    this.loadAccounts()
    return this.reloadInfo()
  }

  init(login) {
    if (isNaN(+login))
      return this.initGuest(login)
    return this.$q((resolve, reject) => {
      this.loadAccounts()
      if (!this.accounts[login] && !(IS_WIZARD && login))
        return reject()
      this.isGuest = false
      this.currentLogin = login
      this.BASE_URL = `/my/webtrader/api/account/${this.currentLogin}`
      return this.reloadInfo().then(resolve, reject)
    })
  }

  DemoAccountCreation() {
    if (this.localStorageService.get(`${this.currentLogin}_demo_account`)){
      let demo_account = this.localStorageService.get(`${this.currentLogin}_demo_account`)
      return this.signIn(demo_account.account, demo_account.password).then(() => {
        return this.init(demo_account.account)
      })
    }
    else {
      return this.$http.post(`${this.BASE_URL}/register_demo_account/`).then(
        (res) => {
          this.localStorageService.set(`${this.currentLogin}_demo_account`, {account: res.data.account, password: res.data.password})
          return this.signIn(res.data.account, res.data.password).then(() => {
            return this.init(res.data.account)
          })
        }
      )
    }
  }

  reloadInfo() {
    return this.$http.get(`${this.BASE_URL}/info/`).then((res) => {
      this.info = res.data
      this.serverName = res.data.server_name
    })
  }

  fastLogin() {
    return this.$http.get('/my/webtrader/api/account/fast_login/').then((res) => {
      this.fastLoginAccounts = res.data || []
    }, (res) => {
      this.fastLoginAccounts = []
    })
  }
}
